export default function ContactUs() {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h1 className="mb-4">Contact Us</h1>
            <p>
              Have questions, feedback, or need assistance? We’d love to hear from you!
            </p>
            <ul className="list-unstyled mt-4">
              <li><strong>Email:</strong> aksemainventory@gmail.com</li>
              <li><strong>Business Hours:</strong> Mon–Fri, 9 AM – 6 PM (GMT+8)</li>
            </ul>
            <p className="mt-4">
              We aim to respond within 24 business hours.
            </p>
          </div>
        </div>
      </div>
    );
  }